import script from "./BackpackInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./BackpackInfo.vue?vue&type=script&setup=true&lang=js"

import "./BackpackInfo.vue?vue&type=style&index=0&id=4360607e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4360607e"]])

export default __exports__